import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from '@/pages/auth/LoginPage';
import RegisterPage from '@/pages/auth/RegisterPage';
import DashboardPage from '@/pages/dashboard/DashboardPage';
import AccountPage from '@/pages/account/AccountPage';
import { AuthCallback } from '@/pages/auth/AuthCallback';
import AuthLayout from '@/components/layouts/AuthLayout';
import SecurityPage from '@/pages/security/SecurityPage';
import JoinOrganizationPage from '@/pages/auth/JoinOrganizationPage';
import { Toaster } from "@/components/ui/toaster";
import TitleManager from "@/components/TitleManager";
import '@/i18n';
import { Suspense } from 'react';

function App() {
  return (
    <>
      <TitleManager />
      <Suspense fallback="Loading...">
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/join-organization/:token" element={<JoinOrganizationPage />} />

            {/* Protected routes */}
            <Route element={<AuthLayout />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/security" element={<SecurityPage />} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Route>
          </Routes>
        </Router>
      </Suspense>
      <Toaster />
    </>
  );
}

export default App;
